import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { CurrenciesApi, CurrenciesApiClient } from '@sg/api/currencies-api';
import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    Currency: {
      entity: CurrenciesApi.CurrencyDto;
      query: CurrenciesApi.CurrenciesSearchRequest & { name: string[] };
    };
  }
}

export class CurrencyApiToEntityFetcherLink implements SgEntityFetchAdapter<'Currency'> {
  protected currencies: CurrenciesApi.CurrencyDto[];
  protected currencies$: Observable<CurrenciesApi.CurrencyDto[]>;
  protected readonly currencyApi: CurrenciesApiClient;

  readonly key: 'Currency' = 'Currency';
  readonly metadata: {
    idField: keyof CurrenciesApi.CurrencyDto;
    labelField: keyof CurrenciesApi.CurrencyDto;
    queryField?: { field: keyof CurrenciesApi.CurrenciesSearchRequest; isArray?: boolean };
  } = {
    idField: 'currencyCode' as 'currencyCode',
    labelField: 'currencyName' as 'currencyName',
    queryField: { field: 'currencyCodes', isArray: true },
  };

  constructor(injector: Injector) {
    this.currencyApi = injector.get(CurrenciesApiClient);
  }

  findEntities(query?: CurrenciesApi.CurrenciesSearchRequest) {
    return this.getCurrencies().pipe(
      map((currencies) => {
        let result = { data: currencies };
        if (!!query) {
          if (query.currencyCodes) {
            const currCodes = query.currencyCodes.map((n) => new RegExp(n, 'i'));
            result.data = currencies.filter((c) => currCodes.some((n) => c.currencyCode.match(n)));
          }
          if (query.currencyNums) {
            const currencyNums = query.currencyNums.map((n) => new RegExp(n, 'i'));
            result.data = currencies.filter((c) => currencyNums.some((n) => c.currencyNum.match(n)));
          }
          if (query.centCodes) {
            const centCodes = query.centCodes.map((n) => new RegExp(n, 'i'));
            result.data = currencies.filter((c) => centCodes.some((n) => c.centCode.match(n)));
          }
        }
        return result;
      })
    );
  }

  getEntity(id: string) {
    return this.getCurrencies().pipe(map((currencies) => currencies.find((c) => c.currencyCode === id)));
  }

  protected getCurrencies(): Observable<CurrenciesApi.CurrencyDto[]> {
    if (this.currencies) {
      return of(this.currencies);
    } else if (this.currencies$) {
      return this.currencies$;
    } else {
      return (this.currencies$ = this.currencyApi
        .currenciesControllerPostCurrenciesSearch({ body: {}, pageSize: 1000 }, { observe: 'body' })
        .pipe(
          map((result) => {
            this.currencies = result.rows;
            this.currencies$ = undefined;
            return result.rows;
          })
        ));
    }
  }
}
